import { useProductTracking } from '~/scopes/product/composables/useProductTracking'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchReviewsSummary } from '~/scopes/product-core/composables/useFetch/useFetchReviewsSummary/useFetchReviewsSummary'
import { useFetchServicePickers } from '~/scopes/product-core/composables/useFetch/useFetchServicePickers/useFetchServicePickers'

/**
 * FIXME: we want to find a better way to handle tracking without having to pass down all the tracking informations.
 */
export function useFetchProductTracking() {
  const { data: productResponse } = useFetchProduct()
  const {
    data: pickersResponse,
    selectedOffer,
    pending: isPickersResponsePending,
  } = useFetchPickers()
  const { data: ratesResponse } = useFetchReviewsSummary()
  const {
    data: servicesPickersResponse,
    pending: isServicesPickersResponsePending,
  } = useFetchServicePickers()

  const data = useProductTracking(
    productResponse,
    selectedOffer,
    ratesResponse,
    pickersResponse,
    isPickersResponsePending,
    servicesPickersResponse,
    isServicesPickersResponsePending,
  )

  return { data }
}
